import React from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const TaskButton = ({ status, submittable, showToolTip, journeyId }) => {
  const onButtonClick = () => {
    if (!submittable) {
      showToolTip(true);
    } else {
      request.patchJSON(routes.JOURNEY.COMPLETE_STEP(journeyId));
      window.location.reload();
    }
  };
  return (
    <button
      onClick={onButtonClick}
      className="JourneyContentButton"
      type="button"
      data-testid="JourneyContentButton"
    >
      {t('journeys.viewer.start_task')}
    </button>
  );
};

export default TaskButton;
